import { gql } from 'apollo-boost'
export const getDepartments = gql`
  {
    departments {
      name
      id
      description
      company {
        id
        name
      }
    }
  }
`
// ID means client js code needs to pass in ObjectId, if Mutation in schema could convert string to
// ObjectId, it'll be simpler
export const updateDepartment = gql`
  mutation updateDepartment($id: ID!, $name: String, $companyId: ID!, $description: String) {
    updateDepartment(id: $id, name: $name, companyId: $companyId, description: $description) {
      id
      name
      companyId
      description
    }
  }
`
export const addDepartment = gql`
  mutation addDepartment($name: ID!, $companyId: ID!, $description: String) {
    addDepartment(name: $name, companyId: $companyId, description: $description) {
      id
      name
      companyId
      description
    }
  }
`
